module.exports = __webpack_public_path__ + "0.7d2f4f9dc0fb23f95f56.worker.js"